import React from 'react'
import styled from 'styled-components'
import { Body1, Body2, Headline4, StandardHeadline } from 'stories/elements/Typography/Text'
import theme from 'stories/utils/theme'
import { Knower } from 'interfaces/Knower'
import ProfilePicture from 'components/elements/ProfilePicture'
import _useTranslation from 'lib/hooks/_useTranslation'
import { User } from 'interfaces/User'
import { GradeBadge, SubjectBadge } from 'components/elements/Badge'
import { sortSubjects } from 'lib/formatting/subjects'
import { returnKnowerFollowersLabel } from 'lib/formatting/knows'
import { useRouter } from 'next/router'

const Container = styled.div`
    display: grid;
    gap: 5px;
    .header {
        display: grid;
        grid-template-columns: 200px 1fr;
        gap: 10px;
        img {
            height: 150px;
            width: 150px;
            border-radius: 50%;
        }
        .stats {
            grid-gap: 20px;
            row-gap: 10px;
            h3,
            p {
                font-family: var(--font-inter);
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                line-height: 28px;
            }
            display: grid;
            grid-template-columns: 1fr 1fr 1fr;
            place-content: center;
        }
        @media (max-width: 750px) {
            h3,
            p {
                font-family: var(--font-inter);
                text-align: center;
                display: flex;
                justify-content: center;
                align-items: center;
                line-height: 28px;
                font-size: 14px;
            }
            gap: 25px;
            grid-template-columns: 1fr;
        }
    }
    .subjects-grades {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        position: relative;
        bottom: 5px;
    }
`

interface Props {
    knower: Knower
    user: User
    onEditBadgeClick?: () => void
    isHeading?: boolean
    showGradeAndSubjects?: boolean
    isDarkTheme?: boolean
}

const KnowerInfo = ({ knower, user, onEditBadgeClick, isHeading, showGradeAndSubjects, isDarkTheme }: Props) => {
    const { t: tKnows } = _useTranslation('knows')
    const { locale } = useRouter()
    const Headile = isHeading ? StandardHeadline : Headline4

    return (
        <Container>
            <div className="header">
                <ProfilePicture user={user} size={150} showEditBadge onEditBadgeClicked={onEditBadgeClick} boxShadow />
                <span />
            </div>
            <Headile fontSize={26} fontWeight={700} color={isDarkTheme ? theme.colors.white : theme.colors.deepSeaBlue}>
                {user.name}
            </Headile>
            <Body2
                color={isDarkTheme ? theme.colors.white : theme.colors.body1Black}
                fontWeight={400}
                fontFamily="var(--font-inter)"
            >
                {returnKnowerFollowersLabel(knower, tKnows, locale)}
            </Body2>

            <Body1
                color={isDarkTheme ? theme.colors.white : theme.colors.body2Black}
                marginBottom={10}
            >{`@${user.username}`}</Body1>
            {showGradeAndSubjects ? (
                <div className="subjects-grades">
                    {user?.grade ? <GradeBadge grades={[user.grade]} isSmall /> : null}
                    {user?.issues?.length
                        ? sortSubjects(user.issues).map((subject) => <SubjectBadge key={subject.id} subject={subject} />)
                        : null}{' '}
                </div>
            ) : null}
            <Body1
                fontFamily="var(--font-inter)"
                fontWeight={400}
                color={isDarkTheme ? theme.colors.grayScaleSecondary : theme.colors.body1Black}
            >
                {user.bio}
            </Body1>
        </Container>
    )
}

export default KnowerInfo
